export enum PencilmarksCheckerMode {
    Off,
    CheckObvious,
    CheckAll,
}
